
const MIN_WIDENABLE_SCOPE_COUNT = 2;
/** Obergrenze, ab der eine Liste nicht mehr als „kurz“ gilt. */
export const CONTEXT_SCOPE_WIDEN_MAX_HITS = 5;

export type ContextScopeWidenMode = "none" | "empty" | "short";

/**
 * Wann die Liste den vom Adapter gelieferten Bereichshinweis anbieten soll:
 * nur bei mindestens zwei zugreifbaren Bereichen, nicht schon „alle“,
 * und nur wenn die Trefferliste leer oder kurz ist.
 */
export function contextScopeWidenMode(input: {
  loaded: boolean;
  allowedCount: number;
  isAll: boolean;
  hitCount: number | null;
  maxHits?: number;
}): ContextScopeWidenMode {
  if (!input.loaded) return "none";
  if (input.allowedCount < MIN_WIDENABLE_SCOPE_COUNT) return "none";
  if (input.isAll) return "none";
  if (input.hitCount == null || !Number.isFinite(input.hitCount) || input.hitCount < 0) return "none";
  if (input.hitCount === 0) return "empty";
  const maxHits = input.maxHits ?? CONTEXT_SCOPE_WIDEN_MAX_HITS;
  if (input.hitCount <= maxHits) return "short";
  return "none";
}
